import { selectUserDepartmentCode } from '../../features/auth/auth-slice';
import { useSelector } from 'react-redux';
import { DEPARTMENT_CODES } from '../../constant/department-code-constant';
import { Navigate } from 'react-router';
import MyTeam from '../general/my-team-page';

export default function MyTeamLayout() {

    const departmentCode  = useSelector(selectUserDepartmentCode);

    switch (departmentCode) {
        case DEPARTMENT_CODES.MKT_GMS:
            return <MyTeam departmentType="GMS" />;

        case DEPARTMENT_CODES.ACTUARIAL:
            return <MyTeam departmentType="ACTUARIAL" />;
    
        case DEPARTMENT_CODES.EBAM:
            return <MyTeam departmentType="EBAM" />;

        default:
            return <Navigate to="/unauthorized" replace />;
    }
}
